import * as ambassadorWixBookingsV2Attendance from './bookings-v2-attendance-attendance.http.js';
import * as ambassadorWixBookingsV2AttendanceTypes from './bookings-v2-attendance-attendance.types.js';
import * as ambassadorWixBookingsV2AttendanceUniversalTypes from './bookings-v2-attendance-attendance.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getAttendance(): __PublicMethodMetaInfo<
  'GET',
  { attendanceId: string },
  ambassadorWixBookingsV2AttendanceUniversalTypes.GetAttendanceRequest,
  ambassadorWixBookingsV2AttendanceTypes.GetAttendanceRequest,
  ambassadorWixBookingsV2AttendanceUniversalTypes.GetAttendanceResponse,
  ambassadorWixBookingsV2AttendanceTypes.GetAttendanceResponse
> {
  const payload = { attendanceId: ':attendanceId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Attendance.getAttendance(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/attendance/{attendanceId}',
    pathParams: { attendanceId: 'attendanceId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function setAttendance(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsV2AttendanceUniversalTypes.SetAttendanceRequest,
  ambassadorWixBookingsV2AttendanceTypes.SetAttendanceRequest,
  ambassadorWixBookingsV2AttendanceUniversalTypes.SetAttendanceResponse,
  ambassadorWixBookingsV2AttendanceTypes.SetAttendanceResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Attendance.setAttendance(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/attendance/set',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkSetAttendance(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsV2AttendanceUniversalTypes.BulkSetAttendanceRequest,
  ambassadorWixBookingsV2AttendanceTypes.BulkSetAttendanceRequest,
  ambassadorWixBookingsV2AttendanceUniversalTypes.BulkSetAttendanceResponse,
  ambassadorWixBookingsV2AttendanceTypes.BulkSetAttendanceResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Attendance.bulkSetAttendance(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/bulk/attendance/set',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryAttendance(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsV2AttendanceUniversalTypes.QueryAttendanceRequest,
  ambassadorWixBookingsV2AttendanceTypes.QueryAttendanceRequest,
  ambassadorWixBookingsV2AttendanceUniversalTypes.QueryAttendanceResponse,
  ambassadorWixBookingsV2AttendanceTypes.QueryAttendanceResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Attendance.queryAttendance(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/attendance/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function countAttendances(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsV2AttendanceUniversalTypes.CountAttendancesRequest,
  ambassadorWixBookingsV2AttendanceTypes.CountAttendancesRequest,
  ambassadorWixBookingsV2AttendanceUniversalTypes.CountAttendancesResponse,
  ambassadorWixBookingsV2AttendanceTypes.CountAttendancesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Attendance.countAttendances(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/attendance/count',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteAttendance(): __PublicMethodMetaInfo<
  'DELETE',
  { attendanceId: string },
  ambassadorWixBookingsV2AttendanceUniversalTypes.DeleteAttendanceRequest,
  ambassadorWixBookingsV2AttendanceTypes.DeleteAttendanceRequest,
  ambassadorWixBookingsV2AttendanceUniversalTypes.DeleteAttendanceResponse,
  ambassadorWixBookingsV2AttendanceTypes.DeleteAttendanceResponse
> {
  const payload = { attendanceId: ':attendanceId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Attendance.deleteAttendance(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v2/attendance/{attendanceId}',
    pathParams: { attendanceId: 'attendanceId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteAttendances(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBookingsV2AttendanceUniversalTypes.BulkDeleteAttendancesRequest,
  ambassadorWixBookingsV2AttendanceTypes.BulkDeleteAttendancesRequest,
  ambassadorWixBookingsV2AttendanceUniversalTypes.BulkDeleteAttendancesResponse,
  ambassadorWixBookingsV2AttendanceTypes.BulkDeleteAttendancesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsV2Attendance.bulkDeleteAttendances(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/bulk/attendance/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Attendance as AttendanceOriginal,
  AttendanceStatus as AttendanceStatusOriginal,
  AttendanceStatusWithLiterals as AttendanceStatusWithLiteralsOriginal,
  GetAttendanceRequest as GetAttendanceRequestOriginal,
  GetAttendanceResponse as GetAttendanceResponseOriginal,
  SetAttendanceRequest as SetAttendanceRequestOriginal,
  ParticipantNotification as ParticipantNotificationOriginal,
  SetAttendanceResponse as SetAttendanceResponseOriginal,
  AttendanceMarkedAsNotAttended as AttendanceMarkedAsNotAttendedOriginal,
  BulkSetAttendanceRequest as BulkSetAttendanceRequestOriginal,
  AttendanceDetails as AttendanceDetailsOriginal,
  BulkSetAttendanceResponse as BulkSetAttendanceResponseOriginal,
  BulkAttendanceResult as BulkAttendanceResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  QueryAttendanceRequest as QueryAttendanceRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryAttendanceResponse as QueryAttendanceResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  CountAttendancesRequest as CountAttendancesRequestOriginal,
  CountAttendancesResponse as CountAttendancesResponseOriginal,
  DeleteAttendanceRequest as DeleteAttendanceRequestOriginal,
  DeleteAttendanceResponse as DeleteAttendanceResponseOriginal,
  BulkDeleteAttendancesRequest as BulkDeleteAttendancesRequestOriginal,
  BulkDeleteAttendancesResponse as BulkDeleteAttendancesResponseOriginal,
  BulkDeleteAttendancesResult as BulkDeleteAttendancesResultOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  GetAttendanceApplicationErrors as GetAttendanceApplicationErrorsOriginal,
  SetAttendanceApplicationErrors as SetAttendanceApplicationErrorsOriginal,
  BulkSetAttendanceApplicationErrors as BulkSetAttendanceApplicationErrorsOriginal,
  DeleteAttendanceApplicationErrors as DeleteAttendanceApplicationErrorsOriginal,
} from './bookings-v2-attendance-attendance.types.js';
